export default __webpack_public_path__ + "static/media/vs.df6261fd.svg";